import { ReduxDispatch } from "models/ReduxProps";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import ActionUtility from "../../utilities/ActionUtility";
import EstimateEffect, { IEstimateRequest } from "./EstimateEffect";
import EstimateModel from "./models/EstimateModel";
import EstimatePrintabelModel from "./models/EstimatePrintabelModel";

type ActionUnion = undefined | HttpErrorResponseModel | EstimateModel | EstimatePrintabelModel;

export default class EstimateAction {
    public static readonly REQUEST_ESTIMATE: string = "EstimateAction.REQUEST_ESTIMATE";
    public static readonly REQUEST_ESTIMATE_FINISHED: string = "EstimateAction.REQUEST_ESTIMATE_FINISHED";
    public static readonly REQUEST_ESTIMATE_PRINT: string = "EstimateAction.REQUEST_ESTIMATE_PRINT";
    public static readonly REQUEST_ESTIMATE_PRINT_FINISHED: string = "EstimateAction.REQUEST_ESTIMATE_PRINT_FINISHED";

    public static readonly REQUEST_ESTIMATE_RESET: string = "AgendaAction.REQUEST_ESTIMATE_RESET";

    public static estimate(request: IEstimateRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<EstimateModel>(
                dispatch,
                EstimateAction.REQUEST_ESTIMATE,
                EstimateEffect.estimate,
                request
            );
        };
    }
    public static print(id: number, idRichiestaPrev: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<EstimatePrintabelModel>(
                dispatch,
                EstimateAction.REQUEST_ESTIMATE_PRINT,
                EstimateEffect.estimatePrintable,
                id,
                idRichiestaPrev
            );
        };
    }
    public static resetPreventivo(): any {
        return ActionUtility.createAction(EstimateAction.REQUEST_ESTIMATE_RESET);
    }
}
